import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    code: yup.number().required(errors.REQUIRED),
  });
};

export default validation;
